import React, { useState } from "react";

import { FormItem } from "src/base-components/FormItem";
import { Input } from "src/base-components/Input";
import { Button } from "src/design-system/Button";
import { Modal } from "src/design-system/Modal";
import { DatasetJob } from "src/jobs/types";

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  isDatasetCreationPending: boolean;
  onCreateFailedDataset: (
    simulationJobRunId: string,
    name: string,
  ) => Promise<DatasetJob>;
  simulationJobRunId: string | undefined;
};

export const CreateDatasetFromFailedRowsModal: React.FC<Props> = ({
  isOpen,
  closeModal,
  isDatasetCreationPending,
  onCreateFailedDataset,
  simulationJobRunId,
}) => {
  const [newDatasetName, setNewDatasetName] = useState("");

  const handleOnClose = () => {
    setNewDatasetName("");
    closeModal();
  };

  const handleOnSubmit = async () => {
    if (!simulationJobRunId) {
      handleOnClose();
      return;
    }
    await onCreateFailedDataset(simulationJobRunId, newDatasetName);
    handleOnClose();
  };

  return (
    <Modal open={isOpen} size="sm" onClose={handleOnClose}>
      <Modal.Header>Create test dataset from failed rows</Modal.Header>
      <Modal.Content>
        <div className="flex w-full flex-col">
          <FormItem isRequired={true} label="Dataset name">
            <Input
              fullWidth={true}
              placeholder="Enter dataset name"
              type="text"
              value={newDatasetName}
              onChange={(e) => setNewDatasetName(e.target.value)}
            />
          </FormItem>
        </div>
      </Modal.Content>
      <Modal.Footer
        primaryButton={
          <Button
            dataLoc="create-failed-rows-dataset"
            isDisabled={!newDatasetName.trim()}
            htmlType="submit"
            isLoading={isDatasetCreationPending}
            variant="primary"
            onClick={handleOnSubmit}
          >
            Create dataset
          </Button>
        }
      />
    </Modal>
  );
};
